import React from "react";
import { ProjectProvider } from "@radarly/core/project/context";
import { useCurrentProjectBootstrap } from "./use-cases";

export default function ProjectConnectedPage({
  id,
  children,
  onAccessError,
  onLoading,
}: {
  id: number;
  children: React.ReactNode;
  onAccessError: () => React.ReactNode;
  onLoading: () => React.ReactNode;
}) {
  const { loading, project, error } = useCurrentProjectBootstrap(id);

  return (
    <ProjectProvider project={project}>
      <React.Suspense fallback={onLoading()}>
        {!loading ? (!!error ? onAccessError() : children) : onLoading()}
      </React.Suspense>
    </ProjectProvider>
  );
}
